<template>
  <div class="orderBox">
    <div class="form-title">应缴保费信息</div>
    <FormItem label="续费年度：" :label-width="180">{{ formData.renewalYear }}</FormItem>
    <FormItem label="当期保费到期日：" :label-width="180">{{ formData.policyExpireDate | dateStrFilter }}</FormItem>
    <FormItem label="年缴保费（A）：" :label-width="180">{{ formData.policyInfo.premium }}</FormItem>
    <FormItem label="当期征费（B）：" :label-width="180">{{ formData.premiumLevy }} </FormItem>
    <FormItem label="当期保费回赠/折扣（C）：" :label-width="180">{{ formData.premiumDiscount }} </FormItem>
    <FormItem label="上年度多缴保费（C1）：" :label-width="180">{{ formData.overpaidPremium }} </FormItem>
    <FormItem prop="duePremium" label="当期应缴保费（D）：" :label-width="180">
      <span>{{ formData.duePremium }}</span>
      <span v-if="formData.policyInfo.currencyType != 3" style="margin-left: 10px">({{ moneyRateLabel }}{{ moneyRateValue }})</span>
    </FormItem>
    <FormItem v-if="$units.isSelfOrg(formData.policyInfo)" prop="attachment" label="缴费通知书：" :label-width="180">
      <uploadNew v-model="formData.attachment" @show="openEye(formData, 'attachment')" showFileName fileType="pdf" :maxUploadLength="1" disabled />
    </FormItem>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import uploadNew from '@/components/commons/maskUploadNew';
import validUserName from '@/components/commons/validUserName';
import { common } from '@/api/mixins';
import Decimal from 'decimal.js';
import _ from 'lodash';
export default {
  mixins: [common],
  props: ['formData'],
  components: { uploadNew, validUserName },
  filters: {
    dateStrFilter(val) {
      if (!val) {
        return '-';
      }
      return val.substring(0, 10);
    }
  },
  computed: {
    moneyRateLabel() {
      const ct = this.formData.policyInfo.currencyType * 1;
      switch (ct) {
        case 1:
          // 港币
          return '参考等值美元：';
        case 2:
          // 美元
          return '参考等值港币：';
        default:
          // 3 人民币
          return '-';
      }
    },
    moneyRateValue() {
      const ct = this.formData.policyInfo.currencyType;
      if (ct == 3) {
        return '-';
      }
      const premium = Number(this.formData.duePremium);
      const r = Number(this.formData.policyInfo.usdToHkdExchangeRate);
      if (isNaN(premium) || isNaN(r)) {
        return '-';
      }
      const d_premium = new Decimal(premium);
      let n = null;
      if (ct == 1) {
        // 港币
        n = d_premium
          .div(new Decimal(r))
          .toFixed(2, Decimal.ROUND_DOWN)
          .toString();
      } else if (ct == 2) {
        // 美元
        n = d_premium
          .mul(new Decimal(r))
          .toFixed(2, Decimal.ROUND_DOWN)
          .toString();
      }
      return n;
    },
    nsChange() {
      const a = this.formData.policyInfo.premium;
      const b = this.formData.premiumLevy;
      const c = this.formData.premiumDiscount;
      const c1 = this.formData.overpaidPremium;
      return { a, b, c, c1 };
    }
  },
  watch: {
    nsChange: {
      handler: _.debounce(function (val) {
        if (this.formData.renewalState != 0 || this.formData.renewalState != 1) return;
        const a = Number(val.a);
        const b = Number(val.b);
        const c = Number(val.c);
        const c1 = Number(val.c1);
        if (isNaN(a) || a === '' || isNaN(b) || b === '' || isNaN(c) || c === '' || isNaN(c1) || c1 === '') {
          return;
        }
        const d = new Decimal(a)
          .add(new Decimal(b))
          .sub(new Decimal(c))
          .sub(new Decimal(c1))
          .toFixed(2, Decimal.ROUND_DOWN)
          .toString();
        const oD = Number(this.formData.duePremium);
        if ((isNaN(oD) || this.formData.duePremium === '' || oD === 0) && !this.isSetD) {
          this.formData.duePremium = d;
          this.calcD = d;
        }
      }, 500),
      immediate: true
    },
    'formData.duePremium'(val) {
      if (val == this.calcD) {
        this.isSetD = false;
      } else {
        this.isSetD = true;
      }
    },
    moneyRateValue: {
      handler(newVal) {
        this.$set(this.formData, '_equalAmount', newVal);
      },
      immediate: true
    }
  },
  methods: {
    openEye(row, code) {
      console.log(row)
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code);
        return;
      }
      if (!row['eyeShow' + code]) {
        this.descrypt(
          {
            id: row[code].id,
            // cardType: cardType[code],
            query: row.id,
            operationFunction: 7,
            operationType: 14,
            cardType: '续费通知书'
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    },
  }
};
</script>
